import React, { useContext, useState, useEffect } from 'react';
import { Collapse } from 'antd';
import styles from './CollapseList.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import { MenuItem, MenuListProps, CollapseListProps, CollapseItem } from './CollapseList.types';
import { useRouter } from 'next/router';
import MobileCollapseList from '../MobileCollapseList';
import { useLanguage } from '@/hooks/use-language';
import Icon from '@ant-design/icons/lib/components/Icon';
import LeftSvg from '../../public/icon/LeftCurrentColor.svg';

const MenuList: React.FC<MenuListProps> = ({ menuList, articleUrl }) => {
  const language = useLanguage();
  return (
    <>
      {menuList.map((item: MenuItem, index: number) => {
        return (
          <Link
            key={index}
            href={{
              pathname: `/${language}/blog/guide${item.blog[0]?.url}`
            }}
            onClick={e => {
              window?.dataLayer?.push({
                event: 'buttonClick',
                buttonTitle: 'content_nav_article',
                description: item?.blog_title || item.blog[0]?.title,
                pageURL: window.location.href,
                componentName: 'content nav'
              });
            }}
          >
            <div
              className={classNames(
                styles.menu_item,
                `/${articleUrl}/` === item.blog[0]?.url && styles.active
              )}
            >
              {item?.blog_title || item.blog[0]?.title}
            </div>
          </Link>
        );
      })}
    </>
  );
};

const CollapseList: React.FC<CollapseListProps> = props => {
  const {
    data: { title, url, table_of_content_entry: collapseList }
  } = props;
  const router = useRouter();
  const language = useLanguage();
  const articleUrl = router.query.article as string;
  const [activeCollaspeIndex, setActiveCollaspeIndex] = useState(0);

  const expandCollapse = (e: string | any[]) => {
    // 如果全部收起了,
    if (e.length === 0) {
      setActiveCollaspeIndex(0);
    } else {
      // 展开对应章节
      setActiveCollaspeIndex(Number(e[0]));
    }
  };

  useEffect(() => {
    // 根据article url 寻找当前展开的目录
    const activeCollaspeIndex =
      collapseList.findIndex(item => {
        return item.blog_post.some(blogItem =>
          blogItem.blog.some(innerBlogItem => innerBlogItem?.url === `/${articleUrl}/`)
        );
      }) + 1;
    setActiveCollaspeIndex(activeCollaspeIndex);
  }, [articleUrl]);

  const items = collapseList?.map((item: CollapseItem, index: number) => ({
    key: index + 1,
    label: (
      <p
        className={styles.collapse_label}
        onClick={e => {
          window?.dataLayer?.push({
            event: 'buttonClick',
            buttonTitle: 'content_nav_article',
            description: item.category_title,
            pageURL: window.location.href,
            componentName: 'content nav'
          });
        }}
      >
        <span className={styles.collapse_label_index}>{index + 1}</span>
        <span>{item.category_title}</span>
      </p>
    ),
    children: <MenuList menuList={item.blog_post} articleUrl={articleUrl} />
  }));

  return (
    <>
      <MobileCollapseList data={props.data}></MobileCollapseList>
      <div className={styles.pc_wrapper}>
        <Link
          href={{ pathname: `/${language}/blog/guide${url}` }}
          onClick={e => {
            window?.dataLayer?.push({
              event: 'buttonClick',
              buttonTitle: 'content_nav_article',
              description: title,
              pageURL: window.location.href,
              componentName: 'content nav'
            });
          }}
        >
          <div className={classNames(styles.menu_item, `/${articleUrl}/` === url && styles.active)}>
            {title}
          </div>
        </Link>
        <Collapse
          ghost
          accordion
          activeKey={activeCollaspeIndex}
          items={items}
          expandIconPosition={'end'}
          expandIcon={({ isActive }) => (
            <>
              {isActive ? (
                <Icon component={LeftSvg} className={styles.collapse_icon_up} />
              ) : (
                <Icon component={LeftSvg} className={styles.collapse_icon_down} />
              )}
            </>
          )}
          // 目录栏点击事件
          onChange={e => expandCollapse(e)}
        />
      </div>
    </>
  );
};

export default CollapseList;
